<style>
.children-module-content {
  /* background: transparent !important; */
  padding: 25px !important;
}
</style>
<template>

  <div class="children-container">
    <div class="children-module-name"><span>职位收藏</span></div>
    <div class="children-module-info">
      <a-table :columns="columns" :data-source="list" rowKey="id" :pagination="false">
        <template slot="natureOfWork" slot-scope="text, record">
          <span v-if="text == 'FULLTIME'">全职</span>
          <span v-if="text == 'PARTTIME'">兼职</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-icon type="eye"  style="margin-right: 10px;"/><a :href="'/recruitment/detail/' + record.id + '.html'" target="_blank">详情</a>
          <span style="margin-left: 10px;cursor: pointer;" @click="cancel(record.id)">
            <a-icon type="delete"  style="margin-right: 10px;"/><span>取消</span>
          </span>
        </template>
      </a-table>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow"
                      v-model="page.start" @change="changePage" />
      </div>

    </div>

  </div>
</template>

<script>
import * as Api from './api';
import * as commonApi from '@/commonApi';

export default {
  data() {
    return {
      modalVisible: false,
      page: {
        start: 1,
        limit: 20,
        pageSize: 0,
        totalRow: 0,
      },
      list: [],
      columns: [
        {
          title: "工作性质",
          dataIndex: "natureOfWork",
          scopedSlots: { customRender: "natureOfWork" },
          width: 150
        },
        {
          title: "岗位名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "发布时间",
          dataIndex: "release_time",
          scopedSlots: { customRender: "release_time" },
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: 150
        },
      ]
    };
  },
  mounted() {
    this.getPage();
  },
  methods: {

    // 获取列表
    async getPage() {
      let res = await Api.GetPage(this.page);
      if (res && res["code"] == "0") {
        this.list = res.page.list;
        this.page.totalRow = res.page.totalRow;
        this.page.pageSize = res.page.pageSize;
      }
    },

    // 切换分页
    changePage(e) {
      this.page.start = e;
      this.getPage();
    },

    // 取消
    async cancel(id) {
      let that = this;
      this.$confirm({
        title: "信息提示",
        okType: "danger",
        content: "您确定要取消收藏吗",
        okText: "确定",
        cancelText: "取消",
        async onOk() {
          let res = await Api.Cancel({ id: id });
          if (res && res["code"] == "0") {
            that.getPage();
            that.$message.success(res.message);
          } else {
            that.$message.error(res.message);
          }
        },
        onCancel() {
        },
      });
    }
  },
};
</script>

<style lang="less">
.tips-text {
  font-size: 14px;
  font-weight: 500;
  color: #007F76;
  line-height: 38px;
  padding-top: 2px;
}

.code {
  background-color: #007F76;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
}
</style>
